import Validator from '../Validator';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBreadcrumbs, useUser } from '../hooks';
import { WorkerBanReason, SetLoading } from '../SiteClasses';
import { Table, Groupper, Header, Button, Input, Pagination, Label, Icon, Modal, Field, Message, Toast } from 'react-frontier';
import { Dropdown } from 'semantic-ui-react';
import { bindClick, bindFormChange } from '../SiteUtil';
import classNames from 'classnames';
import moment from 'moment';
import UserAccess from '../UserAccess';
import API from '../API';

const PAGE_SIZE = 20;

interface ReasonForm{
	reason_id?: number;
	reason_name: string;
}

interface BanReasonsProps{
	
}

var BanReasons = (props: BanReasonsProps)=>{
	var { t } = useTranslation();
	var { setTitle } = useBreadcrumbs();
	var { user, hasAccess } = useUser();
	var [loadError, setLoadError] = useState<string>(null);
	var [reasons, setReasons] = useState<WorkerBanReason []>(null);
	var [filter, setFilter] = useState<string>('');
	var [searchReasons, setSearchReasons] = useState<WorkerBanReason []>(null);
	var [searchTimeout, setSearchTimeout] = useState<any>(null);
	var [searching, setSearching] = useState<boolean>(false);
	var [loading, setLoading] = useState<boolean>(false);
	var [page, setPage] = useState<number>(0);
	var [createModal, setCreateModal] = useState<boolean>(false);
	var [reasonForm, setReasonForm] = useState<ReasonForm>(null);
	var [modalPrompts, setModalPrompts] = useState<string[]>([]);
	var [infoModal, setInfoModal] = useState<boolean>(false);
	var [selectedReason, setSelectedReason] = useState<WorkerBanReason>(null);
	var [deleteModal, setDeleteModal] = useState<boolean>(false);

	var submit = (setLoading: SetLoading) => {
		var { valid, prompts } = Validator(reasonForm, {
			reason_name: [{ rule: 'length', params: [3, 64], label: 'Razón de baneo' }]
		});
		setModalPrompts(prompts);
		if(!valid) return;
		setLoading(true);
		
		if(!reasonForm.reason_id){
			API.createWorkerBanReason(reasonForm.reason_name).then(res=>{
				if(res.error) return setModalPrompts([res.message]);
				Toast.success('Razón de baneo creada!');
				
				reasons.push({
					reason_id: res.data.reason_id,
					reason_name: reasonForm.reason_name,
					deleted: false,
					date_created: moment().unix(),
					user_creator_name: (user.first_name + ' ' + user.last_name),
					user_creator: user.user_id,
					date_deleted: null,
					user_deleted: null,
					user_deleted_name: null
				});
				setReasons(reasons);
				setCreateModal(false);
			}).catch(err => {
				Toast.error('Hubo un error inesperado creando la razón. (GWB-CRT-1)');
			}).finally(()=>{
				setLoading(false);
			});
		}else{
			API.editWorkerBanReason(reasonForm.reason_id, reasonForm.reason_name).then(res=>{
				if(res.error) return setModalPrompts([res.message]);
				Toast.success('Razón de baneo actualizada!');

				var i = reasons.findIndex(r => r.reason_id === reasonForm.reason_id);
				reasons[i].reason_name = reasonForm.reason_name;
				setReasons(reasons);
				setCreateModal(false);
			}).catch(err=>{
				Toast.error('Hubo un error inesperado actualizando la razón. (GWB-EDT-1)');
			}).finally(()=>{
				setLoading(false);
			});
		}
	}
	
	useEffect(()=>{
		setTitle('Razones de Baneo');
		get();
	}, []);

	var get = (get_page?: number)=>{
		var offset = (get_page > 0) ? Math.max(0, (get_page || page) * PAGE_SIZE) : 0;
		setLoading(true);

		API.getBanReasons(PAGE_SIZE, offset).then(res=>{
			if(res.error) return setLoadError(res.message);
			return setReasons(res.data);
		}).catch(err => {
			return setLoadError('Hubo un error al obtener las razones de baneo. (GWB-1)');
		}).finally(()=>{
			setLoading(false);
		});
	};

	var onPageChange = (page: number)=>{
		setLoading(true)
		setPage(page);
		get(page);
	}	
	
	var search = (query: string)=>{
		setSearching(true);
		setSearchTimeout(null);
		API.searchBanReasons(query).then(res=>{
			if(res.error) return setLoadError(res.message);
			setSearchReasons(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al buscar las razones de baneo. (GWB-SRCH-1)');
		}).finally(()=>{
			setSearching(false);
		})
	};

	var onSearchChange = (val: string)=>{
		setFilter(val);
		if(searchTimeout) clearTimeout(searchTimeout);
		if(val.length<3){
			return setSearchReasons(null);
		}
		setSearchTimeout(setTimeout(()=>{
			search(val)
		}, 500));
	}

	var onShowCreateModal = (r: WorkerBanReason)=>{
		if(!!r){
			setReasonForm({
				reason_id: r.reason_id,
				reason_name: r.reason_name
			})
		}else{
			setReasonForm({
				reason_id: null,
				reason_name: ''
			})
		}
		setModalPrompts([]);
		setCreateModal(true);
	}

	var onShowInfoModal = (r: WorkerBanReason) =>{
		setSelectedReason(r);
		setInfoModal(true);
	}

	var onShowDeleteModal = (r: WorkerBanReason)=>{
		setSelectedReason(r);
		setDeleteModal(true);
	}

	var deleteReason = (setLoading: SetLoading)=>{
		setLoading(true);
		API.deleteWorkerBanReason(selectedReason.reason_id).then(res=>{
			if(res.error) return Toast.error(res.message);
			Toast.success('Razón de baneo eliminada!');

			var i = reasons.findIndex(r => r.reason_id === selectedReason.reason_id);
			reasons[i].deleted = true;
			setReasons(reasons);
			setDeleteModal(false);
			setSelectedReason(null);
		}).catch(err=>{
			Toast.error('Hubo un error inesperado eliminando la razón. (GWB-DEL-1)');
		}).finally(()=>{	
			setLoading(false);
		})
	}

	if(loadError) { return <Header text='Error' subtext={loadError} />};
	if(!reasons) { return <Header text='Cargando datos' loading/> };

	var onFormChange = bindFormChange(reasonForm, setReasonForm);
	var shown_reasons = searchReasons || reasons;

	return <div>
		<Groupper
			width={700}
			title={'Razones de baneo'}
			style={{ marginTop: 20 }}
			titleRight={hasAccess(UserAccess.WORKERS.CREATE_BAN_REASON) && (
				<Button iconName='plus' color='black' text='Agregar' size='small' onClick={bindClick(onShowCreateModal, null)}/>
			)}
		>
			<Input placeholder='Buscar...' value={filter} onChange={onSearchChange} style={{ margin: 0 }} />
			<Table
				striped
				className='first last'
				style={{ marginTop: 15 }}
				headers={['ID', 'Razón', 'Creador', 'creación', <Icon name='wrench' />]}
				footer={((shown_reasons && shown_reasons.length >= PAGE_SIZE) || page !== 0) && (
					<Table.Cell colSpan={10} row>
						<div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
							<Pagination page={page} onPageChange={onPageChange} hasNext={shown_reasons && shown_reasons.length>=PAGE_SIZE} />
						</div>
					</Table.Cell>
				)}
			>
				{searching || loading ? (
					<Table.Cell row className='empty' colSpan={5}>
						<Header loading text='Cargando datos' />
					</Table.Cell>
				) : (
					shown_reasons && shown_reasons.length !== 0 ? (
						shown_reasons.map(r => (
							<Table.Row
								key={r.reason_id}
								collapsingIndexes={[0 ,2 ,3, 4]}
								data={[
									r.reason_id,
									r.reason_name,
									r.user_creator_name || '-',
									r.date_created ? moment.unix(r.date_created).format('DD/MM/YY HH:mm') : '-',
									<Dropdown icon={(
										<div className="fr label" style={{ padding: '3px 10px' }}>
											<Icon name='ellipsis' style={{ margin: 0 }} />
										</div>
									)} className='icon'>
										<Dropdown.Menu>
											<Dropdown.Item onClick={bindClick(onShowInfoModal, r)}>
												<Icon name="eye" style={{ marginRight: 3 }} /> Info 
											</Dropdown.Item>
											{hasAccess(UserAccess.WORKERS.EDIT_BAN_REASON) && (
												<Dropdown.Item onClick={bindClick(onShowCreateModal, r)}>
													<Icon name="pen" style={{ marginRight: 3 }} /> Editar 
												</Dropdown.Item>
											)}
											{!r.deleted && hasAccess(UserAccess.WORKERS.DELETE_BAN_REASON) && (
												<Dropdown.Item onClick={bindClick(onShowDeleteModal, r)}>
													<Icon name="remove" style={{ marginRight: 3 }} /> Eliminar 
												</Dropdown.Item>
											)}
										</Dropdown.Menu>
									</Dropdown>
								]}
							/>
						))
					) : (
						<Table.Cell row className='empty' colSpan={5}>
							No se encontraron registros
						</Table.Cell>
					)
				)}
			</Table>
		</Groupper>
		<Modal open={createModal} onClose={bindClick(setCreateModal, false)} size='tiny'>
			{reasonForm && <Modal.Header>{reasonForm.reason_id ? 'Editar razón de baneo' : 'Crear razón de baneo'}</Modal.Header>}
			{reasonForm && <Modal.Content>
				<Input 
					label='Razón de baneo' 
					comment='Descripción de la razón de baneo' 
					value={reasonForm.reason_name} 
					onChange={onFormChange('reason_name')}
					maxLength={64}
				/>
				<Message type="error" list={modalPrompts} />
			</Modal.Content>}
			<Modal.Actions>
				<Button basic text='Cancelar' onClick={bindClick(setCreateModal, false)}/>
				{reasonForm && <Button color="black" text={reasonForm.reason_id ? 'Guardar' : 'Crear'} onClick={submit}/>}
			</Modal.Actions>
		</Modal>
		<Modal open={infoModal} onClose={bindClick(setInfoModal)} size='mini'>
			<Modal.Header>Información de razón de baneo</Modal.Header>
			{selectedReason && <Modal.Content style={{ paddingBottom: 0 }}>
				<Table 
					details
					striped
					fitted
					data={[
						['ID', selectedReason.reason_id],
						['Razón', selectedReason.reason_name],
						['Creador', selectedReason.user_creator_name || '-'],
						['Creación', selectedReason.date_created ? moment.unix(selectedReason.date_created).format('DD/MM/YY HH:mm') : '-'],
					]}
				/>
			</Modal.Content>}
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={bindClick(setInfoModal)} />
			</Modal.Actions>
		</Modal>
		<Modal open={deleteModal} onClose={bindClick(setDeleteModal)} size='tiny'>
			<Modal.Header>¿Eliminar razón de baneo?</Modal.Header>
			{selectedReason && <Modal.Content style={{ paddingBottom: 0 }}>
				<Table 
					details
					striped
					fitted
					data={[
						['ID', selectedReason.reason_id],
						['Razón', selectedReason.reason_name],
					]}
				/>
				<Message type="error" list={modalPrompts} />
			</Modal.Content>}
			<Modal.Actions>
				<Button text='Cerrar' basic onClick={bindClick(setDeleteModal)} />
				<Button text='Eliminar' color='red' onClick={deleteReason}/>
			</Modal.Actions>
		</Modal>
	</div>
};	

export default BanReasons;